<template lang="pug">

  v-container.pageGroupContainer(tag="section" fluid)

    //-
      -
      -
      VOLTAR + PLANO
      -
      -
      -

    v-row

      v-col(cols="12" sm="6").column

        sos-button(@buttonClick="goBackToGroupScales" size="medium" color="default" buttonLabel="Voltar para o grupo" buttonIcon="mdi-arrow-left" buttonIconSize="16").mr-auto.btnVoltar

    .pageBody

      //-
        -
        -
        CABEÇALHO (IMAGEM DO GRUPO, INFORMAÇÕES DO GRUPO E BOTÕES [CONVIDAR E ETC])
        -
        -
        -

      .groupUserDutiesPageHeader

        .csCol.csCol--1

          .groupTitleArea

            .groupTitleImage
              .groupImage
                .groupUserImage(:style="{ backgroundImage: 'url(' + (group && group.img ? group.img : groupPlaceholder) + ')' }")

            .groupTitleText
              h2.blockTitle {{ group && group.nome ? group.nome : 'Carregando...' }}

          //- .groupTitleArea

            .groupTitleImage

              .groupImage

                .groupUserImage(:style="{ backgroundImage: 'url(' + userLocalProfile.userImage + ')' }" v-if="userLocalProfile && userLocalProfile.userImage")
                .groupUserImage(v-else)

            .groupTitleText

              h2.blockTitle(v-if="loadingUserProfile === false") {{ userLocalProfile.userName.length === 0 ? 'Não informado' : userLocalProfile.userName }}
              h2.blockTitle(v-else)
                | Carregando...

        .csCol.csCol--2.text-right

          v-tooltip(top color="rgba(0, 0, 139, 0.95)")
            template(v-slot:activator="{ on, attrs }")
              .btnInlineBlock(v-bind="attrs" v-on="on")
                sos-button(@buttonClick="exportAppointments" :disabled="disableExportAppointments" :loading="disableExportAppointments" size="medium" color="success" buttonLabel="Exportar" buttonIcon="mdi-microsoft-excel" buttonIconSize="16").mr-auto.btnVoltar
            span(style="vertical-align: middle")
              i(aria-hidden="true" class="mdi mdi-information-outline" style="font-size: 18px; display: inline-block; vertical-align: middle;")
              b(style="display: inline-block; vertical-align: middle;") &nbsp;Exportar os agendamentos em formato Excel

        .userProfile

          .sosFieldGroup(style="z-index: 3")

            .sosField.sosFieldColumn--1

              .periodSeletor
                label.csLabel
                  span(v-html="'Período:'")
                .csFields.csFields--date
                  date-picker(v-model="selectedDates" :clearable="false" :editable="false" :disabled="loadingAppointments !== 'DONE'" range type="date" valueType="format" format="DD/MM/YYYY" :lang="lang" @change="setDateRange").appointmentsFieldPeriod

            .sosField.sosFieldColumn--2

              template(v-if="haveScales")
                sos-select(label="Especialidade:" :items="selectScales" @sosSelectChanged="onSelectScale" :default="scaleID" :disabled="loadingAppointments !== 'DONE'")

              template(v-else-if="listeners.loadingGroupScales === 'yes'")
                .sosSelectWrapper
                  label.sosSelectTitle
                    span Especialidade:
                  .sosSelect.sosSelect--customError
                    v-progress-circular(color="primary" indeterminate :size="20" :width="1")
                    span.loadingText.loadingText--verticalCenter Carregando...

              template(v-else-if="!!listeners === true && !!listeners.groupScales === true && Array.isArray(listeners.groupScales) && listeners.groupScales.length === 0")
                .sosSelectWrapper
                  label.sosSelectTitle
                    span Especialidade:
                  .sosSelect.sosSelect--customError
                    i.mdi.mdi-close(aria-hidden="true" style="vertical-align: middle")
                    span.loadingText.loadingText--verticalCenter O grupo não tem especialidades.

              template(v-else)
                .sosSelectWrapper
                  label.sosSelectTitle
                    span Especialidade:
                  .sosSelect.sosSelect--customError
                    i.mdi.mdi-close(aria-hidden="true" style="vertical-align: middle")
                    span.loadingText.loadingText--verticalCenter Desconhecido.

          .sosFieldGroup.mt-1(style="z-index: 2")

            .sosField

              template(v-if="groupUsersStatus === 'DONE'")
                sos-select(label="Município(s):" :multiple="true" :items="groupMunicipalities" @sosSelectChanged="onMunicipalitySelect" :default="''" :disabled="loadingAppointments !== 'DONE'")

              template(v-else)
                .sosSelectWrapper
                  label.sosSelectTitle
                    span Município(s):
                  .sosSelect.sosSelect--customError
                    v-progress-circular(color="primary" indeterminate :size="20" :width="1")
                    span.loadingText Carregando...

          .sosFieldGroup.mt-1(style="z-index: 1")

            .sosField

              template(v-if="groupUsersStatus === 'DONE' && loadingAppointments === 'DONE' && units.length > 1")

                sos-select(label="Unidade(s):" :multiple="true" :items="units" @sosSelectChanged="onUnitSelect" :default="''")
                //- :disabled="loadingAppointments !== 'DONE'"

              template(v-else-if="groupUsersStatus === 'DONE' && loadingAppointments === 'DONE' && units.length <= 1")

                .sosSelectWrapper
                  label.sosSelectTitle
                    span Unidade(s):
                  .sosSelect.sosSelect--customError
                    i.mdi.mdi-close(aria-hidden="true" style="vertical-align: middle")
                    span.loadingText.loadingText--verticalCenter Não há unidades na busca atual.

              template(v-else)

                .sosSelectWrapper
                  label.sosSelectTitle
                    span Unidade(s):
                  .sosSelect.sosSelect--customError
                    v-progress-circular(color="primary" indeterminate :size="20" :width="1")
                    span.loadingText Carregando...

      //-
        -
        -
        PRÓXIMOS PLANTÕES
        -
        -
        -

      .mb-3.mt-8.text-right(v-if="filteredAppointments.length > 1")
        sos-button(@buttonClick="expandAll()" size="small" buttonIcon="mdi-plus" buttonLabel="Abrir tudo" buttonIconSize="20" color="purple")
        sos-button(@buttonClick="collapseAll()" size="small" buttonIcon="mdi-minus" buttonLabel="Fechar tudo" buttonIconSize="20" color="danger").ml-1

      .groupUserDutiesHeader(:class="{ 'groupUserDutiesHeader--margin': filteredAppointments.length <= 1 }")

        .loadingScale(v-if="loadedAppointmentsCount === 0")
          | Agendamentos
        .loadingScale(v-else-if="selectedMunicipalities.includes('0') && selectedUnits.includes('0')")
          | {{ `${loadedAppointmentsCount} agendamentos no total` }}
        .loadingScale(v-else)
          | {{ `${loadedAppointmentsCount === 1 ? '1 agendamento' : `${loadedAppointmentsCount} agendamentos`} no total e ${filteredAppointmentsCount === 1 ? '1 agendamento filtrado' : `${filteredAppointmentsCount} agendamentos filtrados`}` }}

      .groupUserDuties(:class="{ 'groupUserDuties--loading': filteredAppointments.length > 0 && loadingAppointments !== 'DONE' }")

        .groupUserDutiesMonthWrapper

          div(v-if="filteredAppointments.length > 0")

            .appointmentDay(v-for="date in filteredAppointments" :class="{ 'appointmentDay--expanded': !!date.expanded === true }")

              .appointmentDateTitle(@click="expandDate(date.date)")

                span {{ date.title }}

                .appointmentDateTitle__icon
                  i.mdi(aria-hidden="true" :class="{ 'mdi-minus': date.expanded === true, 'mdi-plus': date.expanded === false }")

                .appointmentDateTitle__amount(v-if="selectedMunicipalities.includes('0') && selectedUnits.includes('0')")
                  | {{ date.appointments.length }}

                .appointmentDateTitle__amount(v-else)
                  | {{ `${date.appointments.filter(y => checkMunicipalitiesAndUnitsFiltering(y)).length} de ${date.appointments.length}` }}

              .appointmentDateBody(v-if="date.expanded")

                table(border="0" cellspacing="0").appointmentsTable

                  thead
                    tr.managerUserItem.managerUserItem--head
                      td(width="130") Início
                      td(width="1") Duração
                      td(width="175") Paciente
                      td(width="1" style="padding: 0").text-center #
                      td(width="175") Município
                      td(width="175") Unidade
                      td Especialidade
                      td(width="1") &nbsp;

                  tbody

                    tr(v-for="(appointment, appointmentIndex) in date.appointments.filter(x => checkMunicipalitiesAndUnitsFiltering(x))" :class="{ 'last': date.appointments.filter(x => checkMunicipalitiesAndUnitsFiltering(x)).length === appointmentIndex + 1 }").managerUserItem

                      td(data-label="Início")
                        | {{ appointment.appointmentDateTitle + ' às ' + appointment.startTime }}

                      td(data-label="Duração:")
                        | {{ `${appointment.duration} min` }}

                      td(data-label="Paciente:")

                        //- span.tdPatientName(:title="appointment.patientName || 'Sem paciente'") {{ appointment.patientName }}

                        template(v-if="!!appointment.patientName === true")

                          v-tooltip(top color="rgba(0, 0, 0, 0.95)")
                            template(v-slot:activator="{ on, attrs }")
                              span.tdPatientName(v-bind="attrs" v-on="on") {{ appointment.patientName }}
                            span(style="vertical-align: middle")
                              i(aria-hidden="true" class="mdi mdi-account" style="font-size: 18px; display: inline-block; vertical-align: middle;")
                              b(style="display: inline-block; vertical-align: middle;" v-html="`&nbsp;${appointment.patientName}`")

                        template(v-else)

                          span.tdPatientName
                            | &nbsp;

                      td(data-label="Presença:" style="padding: 0")

                        span.tdPatientName.text-center

                          template(v-if="appointment.patientAttendance === 'Sim'")

                            v-tooltip(top color="rgba(34, 139, 34, 0.95)")
                              template(v-slot:activator="{ on, attrs }")
                                .btnInlineBlock(v-bind="attrs" v-on="on" style="width: 30px")
                                  i.mdi.mdi-check-bold(aria-hidden="true" style="color: green")
                              span(style="vertical-align: middle")
                                i(aria-hidden="true" class="mdi mdi-information-outline" style="font-size: 18px; display: inline-block; vertical-align: middle;")
                                b(style="display: inline-block; vertical-align: middle;") &nbsp;Paciente compareceu

                          template(v-else-if="appointment.patientAttendance === 'Não'")

                            v-tooltip(top color="rgba(255, 0, 0, 0.95)")
                              template(v-slot:activator="{ on, attrs }")
                                .btnInlineBlock(v-bind="attrs" v-on="on" style="width: 30px")
                                  i.mdi.mdi-close-thick(aria-hidden="true" style="color: red")
                              span(style="vertical-align: middle")
                                i(aria-hidden="true" class="mdi mdi-information-outline" style="font-size: 18px; display: inline-block; vertical-align: middle;")
                                b(style="display: inline-block; vertical-align: middle;") &nbsp;Paciente não compareceu

                          template(v-else)

                            v-tooltip(top color="rgba(0, 0, 0, 0.95)")
                              template(v-slot:activator="{ on, attrs }")
                                .btnInlineBlock(v-bind="attrs" v-on="on" style="width: 30px")
                                  i.mdi.mdi-help-circle(aria-hidden="true" style="color: #CCCCCC; font-size: 20px; line-height: 40px")
                              span(style="vertical-align: middle")
                                i(aria-hidden="true" class="mdi mdi-information-outline" style="font-size: 18px; display: inline-block; vertical-align: middle;")
                                b(style="display: inline-block; vertical-align: middle;") &nbsp;Sem informação de comparecimento

                      td(data-label="Município:")

                        //- span.tdPatientName(:title="appointment.ownerName") {{ appointment.ownerName }}

                        v-tooltip(top color="rgba(0, 0, 0, 0.95)")
                          template(v-slot:activator="{ on, attrs }")
                            span.tdPatientName(v-bind="attrs" v-on="on") {{ appointment.ownerName }}
                          span(style="vertical-align: middle")
                            i(aria-hidden="true" class="mdi mdi-earth" style="font-size: 18px; display: inline-block; vertical-align: middle;")
                            b(style="display: inline-block; vertical-align: middle;" v-html="`&nbsp;${appointment.ownerName}`")

                      td(data-label="Unidade:")

                        //- span.tdPatientName(:title="appointment.unitName || 'Sem unidade de atendimento'") {{ appointment.unitName }}

                        template(v-if="!!appointment.unitName === true")

                          v-tooltip(top color="rgba(0, 0, 0, 0.95)")
                            template(v-slot:activator="{ on, attrs }")
                              span.tdPatientName(v-bind="attrs" v-on="on") {{ appointment.unitName }}
                            span(style="vertical-align: middle")
                              i(aria-hidden="true" class="mdi mdi-hospital-building" style="font-size: 18px; display: inline-block; vertical-align: middle;")
                              b(style="display: inline-block; vertical-align: middle;" v-html="`&nbsp;${appointment.unitName}`")

                        template(v-else)

                          span.tdPatientName
                            | &nbsp;

                      td(data-label="Especialidade:")

                        v-tooltip(top color="rgba(0, 0, 0, 0.95)")
                          template(v-slot:activator="{ on, attrs }")
                            span.tdSpecialtyName(v-bind="attrs" v-on="on") {{ appointment.specialtyName }}
                          span(style="vertical-align: middle")
                            i(aria-hidden="true" class="mdi mdi-stethoscope" style="font-size: 18px; display: inline-block; vertical-align: middle;")
                            b(style="display: inline-block; vertical-align: middle;" v-html="`&nbsp;${appointment.specialtyName}`")

                      td(data-label="Ações:")

                        sos-button(@buttonClick="openAppointmentEditModal(appointment)" size="small" buttonIcon="mdi-open-in-new" buttonIconSize="20" color="success")

          .px-4.py-2(v-else-if="filteredAppointments.length === 0 && loadingAppointments !== 'DONE'")

            .loadingScale(v-if="loadingAppointments === 'WAITING'")
              .d-flex.align-center
                v-progress-circular(color="primary" indeterminate :size="25" :width="1")
                span.loadingText.loadingText--verticalCenter Aguardando...
            .loadingScale(v-else-if="loadingAppointments === 'LOADING_APPOINTMENTS'")
              .d-flex.align-center
                v-progress-circular(color="primary" indeterminate :size="25" :width="1")
                span.loadingText.loadingText--verticalCenter Carregando agendamentos...
            .loadingScale(v-else-if="loadingAppointments === 'PROCESSING_PATIENTS'")
              .d-flex.align-center
                v-progress-circular(color="primary" indeterminate :size="25" :width="1")
                span.loadingText.loadingText--verticalCenter Processando pacientes...
            .loadingScale(v-else-if="loadingAppointments === 'LOADING_PATIENTS'")
              .d-flex.align-center
                v-progress-circular(color="primary" indeterminate :size="25" :width="1")
                span.loadingText.loadingText--verticalCenter {{ loadingPatients === 1 ? `Carregando 1 paciente...` : `Carregando ${loadingPatients} pacientes...` }}
            .loadingScale(v-else-if="loadingAppointments === 'PROCESSING'")
              .d-flex.align-center
                v-progress-circular(color="primary" indeterminate :size="25" :width="1")
                span.loadingText.loadingText--verticalCenter Processando a lista...

          .pa-4(v-else)

            .loadingScale(v-if="listeners.loadingGroupScales === 'no' && haveScales === false" v-html="'O grupo ainda não tem especialidades'")

            .loadingScale(v-else-if="scaleID === 'all'" v-html="currentRange.isEqual ? `Nenhum resultado em <span style=\"color: #228b22; font-weight: 500\">${currentRange.startDay} de ${currentRange.equalDatesMonthName} de ${currentRange.startYear}</span>` : `Nenhum resultado entre <span style=\"color: #228b22; font-weight: 500\">${currentRange.startDate} e ${currentRange.endDate}</span>`")

            .loadingScale(v-else v-html="currentRange.isEqual ? `Nenhum resultado em <span style=\"color: #228b22; font-weight: 500\">${currentRange.startDay} de ${currentRange.equalDatesMonthName} de ${currentRange.startYear}</span> na especialidade <span style=\"color: #228b22; font-weight: 500\">${scaleName}</span>` : `Nenhum resultado entre <span style=\"color: #228b22; font-weight: 500\">${currentRange.startDate} e ${currentRange.endDate}</span> na especialidade <span style=\"color: #228b22; font-weight: 500\">${scaleName}</span>`")

    //-
      -
      -

    detalhes-da-consulta(ref="appointmentEditModal" v-if="groupUsers")

    //-
      -
      -

    confirm-dialog(ref="cdConfirmModal" :title="cdParameters.title" :text="cdParameters.text" :buttonPosition="cdParameters.buttonPosition" :width="cdParameters.width" @close="cdAction")

</template>

<script>

  import { apiOpenReport } from '@/services/report'

  // DATE PICKER
  import DatePicker from 'vue2-datepicker'
  import 'vue2-datepicker/index.css'

  // Vuex
  import { mapState } from 'vuex'

  import groupPlaceholder from '@/assets/images/groupplaceholder.png'

  import { apiGetSpecialtyAppointments, apiGetGroupMonthConsultationsNoRef } from '@/services/consultations'
  // import { apiGetSpecialtyAppointmentsRef, apiGetGroupMonthConsultationsRef } from '@/services/consultations'
  // import { apiRefOpen, apiRefClose, getPatientByID } from '@/services/firebase'
  import { getPatientByID } from '@/services/firebase'

  // Mixins
  import confirmDialogMixin from '@/mixins/cd.mixin.js'

  //
  //

  import SosSelect from '@/components/SosSelect'
  import SosButton from '@/components/SosButton'
  import ConfirmDialog from '@/modals/ConfirmDialog'

  import DetalhesDaConsulta from '@/modals/DetalhesDaConsulta'

  //
  // moment

  import moment from 'moment'
  import 'moment/locale/pt-br'
  // moment.locale('pt-BR')

  //
  //
  //

  const selectMonths = { '01': 'Janeiro', '02': 'Fevereiro', '03': 'Março', '04': 'Abril', '05': 'Maio', '06': 'Junho', '07': 'Julho', '08': 'Agosto', '09': 'Setembro', 10: 'Outubro', 11: 'Novembro', 12: 'Dezembro' }

  const toTitleCase = name => {
    return name
      .toLowerCase() // Converte todos os caracteres para minúsculas
      .split(/\s+/) // Divide o nome por espaços
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Converte a primeira letra de cada palavra para maiúscula
      .join(' ') // Junta as palavras com espaço entre elas
  }

  export default {
    name: 'Agendamentos',

    components: {
      'detalhes-da-consulta': DetalhesDaConsulta,

      'date-picker': DatePicker,

      'sos-select': SosSelect,
      'sos-button': SosButton,
      'confirm-dialog': ConfirmDialog,
    },

    mixins: [
      confirmDialogMixin,
    ],

    data () {
      return {
        allUsers: [],

        units: [
          {
            key: 'unit_0',
            value: '0',
            rawText: 'Todas as unidades',
            formattedText: '<div class="userShiftsScaleItem"><i aria-hidden="true" class="mdi mdi-home-group userShiftsScaleItemIcon"></i><span class="userShiftsScaleItemText">Todas as unidades</span></div>',
            text: 'Todas as unidades',
            checked: true,
          },
        ],
        selectedUnits: ['0'],

        groupMunicipalities: [],
        selectedMunicipalities: ['0'],

        cachedGroupPatients: [],

        groupPlaceholder,

        loadedAppointmentsCount: 0,
        loadingAppointments: 'WAITING',
        loadingPatients: 0,

        dutiesRef: null,
        appointmentsDates: [],

        scaleID: 'all',
        scaleName: 'Todas as especialidades',

        // SELETOR DE MÊS E ANO
        selectedDates: [],
        currentRange: {
          isEqual: false,

          equalDatesMonthName: '',

          startDate: '',
          startDay: '',
          startMonth: '',
          startYear: '',

          endDate: '',
          endDay: '',
          endMonth: '',
          endYear: '',
        },

        // DATEPICKER
        lang: {
          formatLocale: {
            months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
            monthsShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
            weekdays: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
            weekdaysShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
            weekdaysMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
          },
          yearFormat: 'YYYY',
          monthFormat: 'MMMM',
        },
      }
    },

    computed: {
      ...mapState(['userSession', 'group', 'listeners', 'groupUsers', 'groupUsersStatus']),

      filteredAppointmentsCount () {
        return (
          this.loadedAppointmentsCount > 0 && (this.selectedMunicipalities.includes('0') === false || this.selectedUnits.includes('0') === false)
        ) ? (
          this.appointmentsDates.filter(x => x.appointments.some(y => this.checkMunicipalitiesAndUnitsFiltering(y))).reduce((sum, date) => sum + date.appointments.filter(y => this.checkMunicipalitiesAndUnitsFiltering(y)).length, 0)
        ) : (
          0
        )
      },

      disableExportAppointments () {
        const show = this.haveScales && this.groupUsersStatus === 'DONE' && this.loadingAppointments === 'DONE'
        return show === false
      },

      filteredAppointments ()
      {
        return this.appointmentsDates.filter(x => {
          return (this.selectedMunicipalities.includes('0') && this.selectedUnits.includes('0')) || (
            //
            this.selectedMunicipalities.includes('0') === false && this.selectedUnits.includes('0') === false ? (
              x.appointments.some(y => /* Municípios específicos + Unidades específicas */ this.selectedMunicipalities.includes(y.ownerID) === true && !!y.unitName === true && this.selectedUnits.includes(y.unitName) === true)
            ) : (
              this.selectedMunicipalities.includes('0') === false && this.selectedUnits.includes('0') === true ? (
                x.appointments.some(y => /* Municípios específicos + Todas as unidades */ this.selectedMunicipalities.includes(y.ownerID) === true)
              ) : (
                this.selectedMunicipalities.includes('0') === true && this.selectedUnits.includes('0') === false ? (
                  x.appointments.some(y => /* Todos os municípios + Unidades específicas */ !!y.unitName === true && this.selectedUnits.includes(y.unitName) === true)
                ) : (
                  true
                )
              )
            )
          )
        })
      },

      haveScales () {
        return !!this.listeners === true && !!this.listeners.groupScales === true && Array.isArray(this.listeners.groupScales) && this.listeners.groupScales.length > 0
      },

      selectScales () {
        if (!!this.listeners.groupScales === false || (!!this.listeners.groupScales === true && !Array.isArray(this.listeners.groupScales))) {
          return []
        }

        return this.listeners.groupScales.length > 0 ? [
          {
            key: 'all',
            value: 'all',
            formattedText: '<div class="userShiftsScaleItem"><i aria-hidden="true" class="mdi mdi-calendar-multiple userShiftsScaleItemIcon"></i><span class="userShiftsScaleItemText">Todas as especialidades</span></div>',
            text: 'Todas as especialidades',
          },
          ...this.listeners.groupScales.map(scale => ({
            key: 'scale_' + scale.scaleID,
            value: scale.scaleID,
            text: scale.scaleName,
          })),
        ] : []
      },
    },

    watch: {
      //
      //
      //

      selectedDates: {
        immediate: true,
        handler (newDates, oldDates)
        {
          if (
            Array.isArray(newDates) &&
            newDates.length === 2 &&
            Array.isArray(oldDates) &&
            oldDates.length === 2
          )
          {
            // Converta as datas no formato DD/MM/YYYY para objetos Moment
            const start = moment(newDates[0], 'DD/MM/YYYY')
            const end = moment(newDates[1], 'DD/MM/YYYY')

            // Calcule a diferença em dias
            const diffInDays = end.diff(start, 'days') // + 1

            // [06/02/25] console.log('::: watch > selectedDates > diffInDays', diffInDays)

            // Restaura o período selecionado anteriormente caso o usuário tenha selecionado um novo período maior do que 31 dias
            if (diffInDays > 31) this.selectedDates = oldDates
          }
        },
      },

      //
      //
      //

      groupUsers: {
        immediate: true,
        deep: true,
        handler (dataNew, dataOld)
        {
          if (!!dataNew === true && Array.isArray(dataNew) && dataNew.length > 0)
          {
            const municipalities = dataNew.filter(m => !!m === true && m.isMunicipality && m.isAdmin)

            this.groupMunicipalities = [
              {
                key: 'municipality_0',
                value: '0',
                rawText: 'Todos os municípios',
                formattedText: '<div class="userShiftsScaleItem"><i aria-hidden="true" class="mdi mdi-earth userShiftsScaleItemIcon"></i><span class="userShiftsScaleItemText">Todos os municípios</span></div>',
                text: 'Todos os municípios',
                checked: true,
              },
              ...municipalities.map(m => ({
                key: `municipality_${m.userID}`,
                value: m.userID,
                rawText: m.userName || m.userID,
                formattedText: `<div class="managerItem"><span class="managerImage" style="background-image: url('${m.userImage}')" title="${m.userName || m.userID}"></span><span class="managerName" title="${m.userName || m.userID}">${m.userName || m.userID}</span></div>`,
                text: m.userName || m.userID,
                checked: false,
              })),
            ]

            this.allUsers = dataNew.map(m => ({ value: m.userID, text: m.userName || m.userID }))
          }
        },
      },

      //
      //
      //

      selectScales: {
        immediate: true,
        handler (defaultNew, defaultOld)
        {
          const oldOptions = typeof defaultOld === 'object' && Array.isArray(defaultOld) ? defaultOld : []
          const newOptions = typeof defaultNew === 'object' && Array.isArray(defaultNew) ? defaultNew : []

          // console.log('::: PLANTÕES DO USUÁRIO -> [selectScales] UPDATED:', oldOptions, newOptions)

          //
          // PRÉ-SELECIONA A PRIMEIRA ESCALA, DEPOIS QUE O AS ESCALAS DO GRUPO FORAM COLOCADAS NO VUEX
          //

          if (oldOptions.length === 0)
          {
            if (newOptions.length > 0 && this.dutiesRef === null)
            {
              const scaleID = newOptions[0].value
              const scaleName = newOptions[0].value === 'all' ? 'Todas as especialidades' : newOptions[0].text

              this.scaleID = scaleID
              this.scaleName = scaleName

              // console.log('::: PLANTÕES DO USUÁRIO -> [selectScales] SYSTEM SELECTED "' + scaleName + '" SCALE. (ID: ' + scaleID + ')')
            }
            else if (this.listeners.loadingGroupScales === 'no' && this.haveScales === false)
            {
              this.loadingAppointments = 'DONE'

              // console.log('::: PLANTÕES DO USUÁRIO -> [selectScales] SYSTEM CAN\'T SELECT SCALE: This group doesn\'t have any scale.')
            }
          }
        },
      },
    },

    // created () {
      // console.log('::: PLANTÕES DO USUÁRIO -> created')
      // console.log('::: PLANTÕES DO USUÁRIO -> created [VUEX]:', this.listeners.groupScales)
    // },

    mounted ()
    {
      // console.log('::: PLANTÕES DO USUÁRIO -> mounted [VUEX]:', this.listeners.groupScales)

      //
      // moment init
      moment.locale('pt-BR')

      //
      // Aplica mês e ano vigentes
      this.setCurrentRange()

      //
      // Carrega dados do grupo caso o usuário não tenha passado pela tela de GRUPO

      // console.log('::: PLANTÕES DO USUÁRIO -> [mounted] LOADING GROUP "' + this.$route.params.groupID + '"...')
      this.$store.dispatch('loadGroupPage', this.$route.params.groupID)

      //
      // DEBUG

      // console.log('::: PLANTÕES DO USUÁRIO -> mounted:', this.$route.params.groupID, this.$store.state.group)
    },

    // https://stackoverflow.com/questions/10246215/how-to-destroy-a-javascript-object
    // https://www.digitalocean.com/community/tutorials/vuejs-component-lifecycle-pt

    updated () {
      if (
        this.dutiesRef === null &&

        this.selectedDates.length === 2 &&
        this.currentRange.startDate.length === 10 &&
        this.currentRange.endDate.length === 10 &&

        this.scaleID !== '' &&
        this.scaleName !== '' &&
        this.groupUsersStatus === 'DONE'
      ) {
        // console.log('::: PLANTÕES DO USUÁRIO -> [updated] LOADING "' + this.scaleName + '" SCALE DUTIES...')

        this.startDuties(this.currentRange)
      }
    },

    beforeDestroy ()
    {
      this.stopDuties()
      this.clearComponent()

      // console.log('::: PLANTÕES DO USUÁRIO -> beforeDestroy:', this.$route.params.groupID, this.$store.state.group)
    },

    // unmounted ()
    // {
      // console.log('::: PLANTÕES DO USUÁRIO -> unmounted:', this.$route.params.groupID, this.$store.state.group)
    // },

    methods: {
      //
      // CUSTOM DIALOG RESPONSE
      //

      cdAction (cdResponse) {
        // [06/02/25] console.log('::: cdAction:', cdResponse)

        // if (cdResponse === false) return false
      },

      //
      // MAINTENANCE
      //

      clearComponent ()
      {
        this.units = []
        delete this.units

        this.selectedUnits = ['0']
        delete this.selectedUnits

        this.groupMunicipalities = []
        delete this.groupMunicipalities

        this.allUsers = []
        delete this.allUsers

        this.selectedMunicipalities = ['0']
        delete this.selectedMunicipalities

        this.cachedGroupPatients = []
        delete this.cachedGroupPatients

        this.groupPlaceholder = groupPlaceholder
        delete this.groupPlaceholder

        this.loadedAppointmentsCount = 0
        delete this.loadedAppointmentsCount

        this.loadingAppointments = 'WAITING'
        delete this.loadingAppointments

        this.loadingPatients = 0
        delete this.loadingPatients

        this.dutiesRef = null
        delete this.dutiesRef

        this.appointmentsDates = []
        delete this.appointmentsDates

        this.scaleID = 'all'
        delete this.scaleID

        this.scaleName = 'Todas as especialidades'
        delete this.scaleName

        this.selectedDates = []
        delete this.selectedDates

        this.currentRange = {
          isEqual: false,

          equalDatesMonthName: '',

          startDate: '',
          startDay: '',
          startMonth: '',
          startYear: '',

          endDate: '',
          endDay: '',
          endMonth: '',
          endYear: '',
        }
        delete this.currentRange
      },

      //
      //
      //

      checkMunicipalitiesAndUnitsFiltering (y)
      {
        return (this.selectedMunicipalities.includes('0') === false && this.selectedUnits.includes('0') === false ? (/* Municípios específicos + Unidades específicas */ this.selectedMunicipalities.includes(y.ownerID) === true && !!y.unitName === true && this.selectedUnits.includes(y.unitName) === true) : (this.selectedMunicipalities.includes('0') === false && this.selectedUnits.includes('0') === true ? (/* Municípios específicos + Todas as unidades */ this.selectedMunicipalities.includes(y.ownerID) === true) : (this.selectedMunicipalities.includes('0') === true && this.selectedUnits.includes('0') === false ? (/* Todos os municípios + Unidades específicas */ !!y.unitName === true && this.selectedUnits.includes(y.unitName) === true) : (true))))
      },

      //
      //
      //

      setCurrentRange (p = { startDate: '', endDate: '' })
      {
        // (ANTIGO) Período padrão = MÊS TODO
        // const startDate = !!p.startDate === true ? p.startDate : moment.utc().startOf('month').format('DD/MM/YYYY')
        // const endDate = !!p.endDate === true ? p.endDate : moment.utc().endOf('month').format('DD/MM/YYYY')

        // (ATUAL - 31/10/24) Período padrão = HOJE até 7 DIAS DEPOIS
        const startDate = !!p.startDate === true ? p.startDate : moment.utc().format('DD/MM/YYYY')
        const endDate = !!p.endDate === true ? p.endDate : moment.utc().add(7, 'days').format('DD/MM/YYYY')

        const nowStartOfMonth = startDate.split('/')
        const newEndOfMonth = endDate.split('/')

        const nowStartDateYear = parseInt(nowStartOfMonth[2])
        const nowStartDateMonth = nowStartOfMonth[1]
        const nowStartDateDay = parseInt(nowStartOfMonth[0])

        const nowEndDateYear = parseInt(newEndOfMonth[2])
        const nowEndDateMonth = newEndOfMonth[1]
        const nowEndDateDay = parseInt(newEndOfMonth[0])

        const currentRange = {
          isEqual: startDate === endDate,

          equalDatesMonthName: selectMonths[nowStartDateMonth],

          startDate,
          startDay: nowStartDateDay,
          startMonth: parseInt(nowStartDateMonth),
          startYear: nowStartDateYear,

          endDate,
          endDay: nowEndDateDay,
          endMonth: parseInt(nowEndDateMonth),
          endYear: nowEndDateYear,
        }

        this.selectedDates = [startDate, endDate]
        this.currentRange = currentRange

        // [06/02/25] console.log('::: setCurrentRange:', currentRange)
      },

      /**
       *
       * DUTIES
       * - LOAD, PROCESS AND UNLOAD
       *
       */

      async startDuties (range)
      {
        // [06/02/25] console.log('::: startDuties')

        if (this.dutiesRef !== null) return false

        this.dutiesRef = true
        // this.dutiesRef = `${String(month)}_${String(year)}`

        //
        //
        //

        this.loadingAppointments = 'LOADING_APPOINTMENTS'
        this.appointmentsDates = []

        const appointments = this.scaleID === 'all' ? (
          await apiGetGroupMonthConsultationsNoRef(this.$route.params.groupID, range)
        ) : (
          await apiGetSpecialtyAppointments(this.scaleID, range)
        )

        this.loadedAppointmentsCount = appointments.length

        this.onAppointmentsUpdate(appointments)
      },

      stopDuties ()
      {
        if (this.dutiesRef === null) return false

        // apiRefClose(this.dutiesRef, this.onAppointmentsUpdate)
        this.dutiesRef = null

        this.loadingAppointments = 'DONE' // Senhor Jesus
        this.appointmentsDates = []
        this.loadedAppointmentsCount = 0

        // console.log('::: PLANTÕES DO USUÁRIO -> STOPPED DUTIES.')
      },

      collapseAll ()
      {
        this.appointmentsDates.forEach(x => {
          x.expanded = false
        })
      },

      expandAll ()
      {
        this.appointmentsDates.forEach(x => {
          x.expanded = true
        })
      },

      async onAppointmentsUpdate (consultations)
      {
        // if (this.loadingAppointments === true) this.loadingAppointments = false

        if (consultations.length === 0)
        {
          this.appointmentsDates = []
          this.loadingAppointments = 'DONE'

          return false
        }

        // this.loadingAppointments = 'PROCESSING_PATIENTS'

        //
        //
        //

        // const municipalityConsultations = consultations.filter(([consultationID, consultation]) => !!consultation === true && consultation.groupID === this.$route.params.groupID && consultation.ownerID === this.municipalityID)

        let units = []

        //
        //
        //

        let patientIds = consultations.filter(([_, c]) => !!c.patientId === true && this.cachedGroupPatients.some(p => p.patientId === c.patientId) === false)

        if (patientIds.length > 0) patientIds = patientIds.map(([_, c]) => c.patientId)

        if (patientIds.length > 0) patientIds = patientIds.length > 0 ? [...new Set(patientIds)] : []

        if (patientIds.length > 0)
        {
          this.loadingPatients = patientIds.length
          this.loadingAppointments = 'LOADING_PATIENTS'

          const loadedPatients = await Promise.all(
            patientIds.map(async id => {
              const p = await getPatientByID(id)

              const fullName = !!p === true ? (String(p.firstName || '').length > 0 && String(p.lastName || '').length > 0 ? `${p.firstName} ${p.lastName}` : (String(p.firstName || '').length > 0 ? p.firstName : (p.lastName || ''))) : ''

              return {
                patientId: id,
                firstName: p.firstName || '',
                lastName: p.lastName || '',
                dateOfBirth: p.dateOfBirth || '',
                email: p.email || '',
                cpf: p.cpf || '',
                group: p.group || '',

                fullName: fullName.trim().length > 0 ? toTitleCase(fullName.trim()) : '',
              }
            })
          )

          this.cachedGroupPatients = [...this.cachedGroupPatients, ...loadedPatients]

          // console.log('::: cachedGroupPatients:', this.cachedGroupPatients)
        }

        //
        //
        //

        this.loadingAppointments = 'PROCESSING'

        const appointmentsDates = []

        consultations.forEach(([consultationID, c]) => {
          // SEARCH FOR PATIENT PROFILE
          const foundPatient = !!c.patientId === true ? this.cachedGroupPatients.find(p => p.patientId === c.patientId) : null
          const patientName = !!foundPatient === true ? foundPatient.fullName : ''

          // SPECIALTY NAME
          const consultationScale = this.listeners.groupScales.find(scale => scale.scaleID === c.scaleID)
          const specialtyName = !!consultationScale === true ? String(consultationScale.scaleName).trim() : ''
          const patientRequired = !!consultationScale === true && !!consultationScale.patientRequired === true

          // ?
          const dutyStartDate = moment.utc(c.timestamp)
          const dutyWeekDay = dutyStartDate.day()
          const dutyWeekDayName = dutyWeekDay === 0 ? 'Domingo' : (dutyWeekDay === 1 ? 'Segunda' : (dutyWeekDay === 2 ? 'Terça' : (dutyWeekDay === 3 ? 'Quarta' : (dutyWeekDay === 4 ? 'Quinta' : (dutyWeekDay === 5 ? 'Sexta' : (dutyWeekDay === 6 ? 'Sábado' : 'Desconhecido'))))))

          //
          //
          //

          const dateObject = !!c.startDate === true && !!c.startTime === true ? moment(`${c.startDate} ${c.startTime}:00`, 'DD/MM/YYYY HH:mm:ss') : null

          const findMunicipality = this.allUsers.find(x => x.value === c.ownerID)

          const consultation = {
            consultationID,
            appointmentDateTitle: !!dateObject === true ? dateObject.format('DD/MM') : '',
            appointmentTimestamp: !!dateObject === true ? dateObject.unix() : 0,
            ownerName: !!findMunicipality === true && !!findMunicipality.text === true ? findMunicipality.text : '',
            ownerID: c.ownerID,
            startDate: c.startDate,
            startTime: c.startTime,

            // JESUS VIVE !!!
            duration: c.duration, // + ' min', // JESUS VIVE !!!
            // JESUS VIVE !!!

            // patientName: c.patientId,
            patientName,
            specialtyId: c.scaleID || '',
            specialtyName,
            patientRequired,

            patientAttendance: !!c.patientAttendance === true ? (c.patientAttendance === '0' ? 'Não' : (c.patientAttendance === '1' ? 'Sim' : '')) : '',

            //
            //
            //

            unitName: !!c.reminder === true && !!c.reminder.unitName === true ? c.reminder.unitName : '',

            //
            //
            //

            // appointment: c,
            appointment: !!foundPatient === true ? { consultationID, ...c, patient: { ...foundPatient } } : c,
          }

          // console.log('::: consultation:', consultationID, c)

          const foundDateIndex = appointmentsDates.findIndex(x => x.date === c.startDate)

          if (foundDateIndex === -1)
          {
            appointmentsDates.push({
              timestamp: !!dateObject === true ? dateObject.unix() : 0,
              date: c.startDate || 'Sem data',
              title: !!dateObject === true ? (dateObject.format('DD/MM') + ` - ${dutyWeekDayName}`) : '[ERRO]',
              // title: !!c.startDate === true ? (dateObject.format('DD/MM') + ` - ${dutyWeekDayName}`) : '[ERRO]',
              expanded: false,
              appointments: [consultation],
            })
          }
          else
          {
            appointmentsDates[foundDateIndex].appointments.push(consultation)
          }

          //
          //
          //

          if (!!c.reminder === true && !!c.reminder.unitName === true) {
            units.push(c.reminder.unitName)
          }
        })

        //
        //
        //

        // ORDEM CRESCENTE (a - b) - ORDEM DECRESCENTE (b - a)
        appointmentsDates.sort((a, b) => a.timestamp - b.timestamp)
        appointmentsDates.forEach((d, _) => {
          d.appointments.sort((a, b) => a.appointmentTimestamp - b.appointmentTimestamp)
        })

        // console.log('::: appointmentsDates:', appointmentsDates)

        //
        //
        //

        if (units.length > 0)
        {
          units = [...new Set(units)]

          units.sort((a, b) => a.localeCompare(b))

          this.units = [
            {
              key: 'unit_0',
              value: '0',
              rawText: 'Todas as unidades',
              formattedText: '<div class="userShiftsScaleItem"><i aria-hidden="true" class="mdi mdi-home-group userShiftsScaleItemIcon"></i><span class="userShiftsScaleItemText">Todas as unidades</span></div>',
              text: 'Todas as unidades',
              checked: true,
            },
            //
            ...units.map((unitName, unitIndex) => ({
              key: `unit_item_${unitIndex}`,
              value: unitName,
              rawText: unitName,
              formattedText: `<div class="userShiftsScaleItem"><i aria-hidden="true" class="mdi mdi-hospital-building userShiftsScaleItemIcon userShiftsScaleItemIcon--normal"></i><span class="userShiftsScaleItemText userShiftsScaleItemText--normal">${unitName}</span></div>`,
              text: unitName,
              checked: false,
            })),
          ]
        }

        //
        //
        //

        this.appointmentsDates = appointmentsDates
        this.loadingAppointments = 'DONE'
      },

      //
      //
      // MUNICIPALITY SELECT EVENT
      //
      //

      async onMunicipalitySelect (optionValue)
      {
        // if (optionValue.indexOf('_') === -1) return false

        // const usuarios = optionValue.split('_')
        const municipalityID = optionValue
        // const managerID = usuarios[1]

        if (this.groupMunicipalities.length === 0) return false

        // console.log('::: onMunicipalitySelect:', municipalityID)

        let newMunicipalities = this.groupMunicipalities.map(subitem =>
          municipalityID === '0' ? { ...subitem, checked: subitem.value === municipalityID } : (
            subitem.value === municipalityID ? { ...subitem, checked: !subitem.checked } : (subitem.value === '0' ? { ...subitem, checked: false } : subitem)
          )
        )

        // Força a marcação do primeiro item caso tenha desmarcado todos
        if (newMunicipalities.some(subitem => subitem.checked) === false) {
          newMunicipalities = newMunicipalities.map(subitem => subitem.value === '0' ? { ...subitem, checked: true } : subitem)
        }

        const newSelectedMunicipalities = newMunicipalities.filter(x => x.checked).map(x => x.value)

        if (this.selectedMunicipalities.includes('0') === false && newSelectedMunicipalities.length > 10) return this.showMessage('Aviso', 'Você pode selecionar até 10 municípios.')

        this.groupMunicipalities = newMunicipalities

        this.selectedMunicipalities = newSelectedMunicipalities
      },

      //
      //
      // UNIT SELECT EVENT
      //
      //

      async onUnitSelect (optionValue)
      {
        const unitID = optionValue

        if (this.units.length === 0) return false

        let newUnits = this.units.map(subitem =>
          unitID === '0' ? { ...subitem, checked: subitem.value === unitID } : (
            subitem.value === unitID ? { ...subitem, checked: !subitem.checked } : (subitem.value === '0' ? { ...subitem, checked: false } : subitem)
          )
        )

        // Força a marcação do primeiro item caso tenha desmarcado todos
        if (newUnits.some(subitem => subitem.checked) === false) {
          newUnits = newUnits.map(subitem => subitem.value === '0' ? { ...subitem, checked: true } : subitem)
        }

        const newSelectedUnits = newUnits.filter(x => x.checked).map(x => x.value)

        if (this.selectedUnits.includes('0') === false && newSelectedUnits.length > 10) return this.showMessage('Aviso', 'Você pode selecionar até 10 unidades.')

        this.units = newUnits

        this.selectedUnits = newSelectedUnits

        // [06/02/25] console.log('::: selectedUnits:', this.selectedUnits)
      },

      //
      //
      // ?
      //
      //

      onSelectScale (scaleID, scaleName)
      {
        this.scaleID = scaleID
        this.scaleName = scaleName

        this.units = [
          {
            key: 'unit_0',
            value: '0',
            rawText: 'Todas as unidades',
            formattedText: '<div class="userShiftsScaleItem"><i aria-hidden="true" class="mdi mdi-home-group userShiftsScaleItemIcon"></i><span class="userShiftsScaleItemText">Todas as unidades</span></div>',
            text: 'Todas as unidades',
            checked: true,
          },
        ]
        this.selectedUnits = ['0']

        this.stopDuties()
        this.startDuties(this.currentRange)
      },

      //
      //
      // NAVIGATION
      //
      //

      openAppointmentEditModal (appointment)
      {
        /* this.$refs.appointmentEditModal.open({
          patientRequired: appointment.patientRequired,
          scaleID: appointment.specialtyId || '',
          scaleName: appointment.specialtyName || '',
          selectedDate: appointment.startDate,
          consultation: {
            ...appointment.appointment,
            // ...(!!this.cachedGroupPatients[appointment.patientName] === true ? { consultationID: appointment.consultationID, ...appointment.appointment, patient: { ...this.cachedGroupPatients[appointment.patientName] } } : appointment.appointment),

            consultationID: appointment.consultationID,
          },
          consultationDuration: appointment.duration,
        }) */

        const appointmentDetails = {
          patientRequired: appointment.patientRequired,

          id: appointment?.consultationID,

          regulationCode: String(appointment?.regulation_code ?? ''),
          confirmationKey: String(appointment?.confirmation_key ?? ''),

          attendanceStatus: String(appointment?.patientAttendance || ''),
          reminderId: String(appointment?.reminder?.id ?? ''),

          scaleID: appointment.specialtyId || '',
          scaleName: appointment.specialtyName || '',

          municipalityID: appointment?.ownerID,

          observation: appointment?.obs || '',

          timestamp: appointment?.timestamp,
          date: appointment.startDate,
          startTime: appointment?.startTime,
          endTime: appointment?.endTime,
          duration: appointment.duration,

          patientID: String(appointment?.patientId || ''),
          patientFirstName: String(appointment?.patient?.firstName ?? '').trim(),
          patientLastName: String(appointment?.patient?.lastName ?? '').trim(),
          patientDateOfBirth: String(appointment?.patient?.dateOfBirth ?? ''),
          patientEmail: String(appointment?.patient?.email ?? ''),
          patientCpf: String(appointment?.patient?.cpf ?? ''),
          patientUnitName: String(appointment?.patient?.group ?? ''),

          doctorID: String(appointment?.doctor?.id ?? ''),
          doctorName: String(appointment?.doctor?.name ?? ''),

          locationType: appointment?.typeOfMedicalCare || '0',
          locationID: String(appointment?.reminder?.group_id ?? ''),
          locationName: String(appointment?.reminder?.unitName ?? ''),
          locationAddress: String(appointment?.reminder?.unitAddress ?? ''),
        }

        this.$refs.appointmentEditModal.open(appointmentDetails)
      },

      // BACK TO THE "GROUP DETAILS" SCREEN
      goBackToGroupScales () {
        this.$router.push(`/admin/grupos/${this.$route.params.groupID}/escalas`)
      },

      // GO TO THE "SUBSCRIPTION" SCREEN
      navigateToPlans () {
        this.$router.push('/admin/assinatura')
      },

      //
      //
      //

      expandDate (date) {
        const foundDate = this.appointmentsDates.find(x => x.date === date)
        foundDate.expanded = !foundDate.expanded
      },

      //
      //
      //

      setDateRange (dates, type)
      {
        // [06/02/25] console.log('::: setDateRange:', dates, type)

        if (type === 'date' && Array.isArray(dates) && dates.length === 2)
        {
          // Converta as datas no formato DD/MM/YYYY para objetos Moment
          const start = moment(dates[0], 'DD/MM/YYYY')
          const end = moment(dates[1], 'DD/MM/YYYY')

          // Calcule a diferença em dias
          const diffInDays = end.diff(start, 'days') // + 1

          // [06/02/25] console.log('::: setDateRange > diffInDays', diffInDays)

          // Não prossegue com o carregamento do novo período selecionado caso o usuário tenha selecionado um período maior do que 31 dias
          if (diffInDays > 31) return this.showMessage('Aviso', `<b style="color: indianred; font-size: 24px; line-height: 1">Selecione um período de até 31 dias.</b><br /><br /><b>Período selecionado</b>:<br />${dates[0]} ~ ${dates[1]}<br /><br /><b>Tamanho do período selecionado</b>:<br /><span style="color: indianred">${diffInDays} dias</span>`)

          //
          // PREPARA PARA FAZER O CARREGAMENTO DO NOVO PERÍODO SELECIONADO
          //

          this.setCurrentRange({ startDate: dates[0], endDate: dates[1] })

          this.units = [
            {
              key: 'unit_0',
              value: '0',
              rawText: 'Todas as unidades',
              formattedText: '<div class="userShiftsScaleItem"><i aria-hidden="true" class="mdi mdi-home-group userShiftsScaleItemIcon"></i><span class="userShiftsScaleItemText">Todas as unidades</span></div>',
              text: 'Todas as unidades',
              checked: true,
            },
          ]
          this.selectedUnits = ['0']

          this.stopDuties()
          this.startDuties(this.currentRange)
        }
      },

      //
      // EXPORT APPOINTMENTS ACCORDING TO THE FILTERS
      //

      exportAppointments ()
      {
        //
        // VALIDATE
        //

        const validDates = Array.isArray(this.selectedDates) && this.selectedDates.length === 2 && /^\d{2}\/\d{2}\/\d{4}$/.test(this.selectedDates[0]) && /^\d{2}\/\d{2}\/\d{4}$/.test(this.selectedDates[1])

        if (validDates === false) {
          this.showMessage('Atenção!', 'Selecione um período')
          return false
        }

        //
        // BUILD REPORT URL
        //

        const scaleId = this.scaleID !== 'all' ? this.scaleID : 'no'
        const municipalities = this.selectedMunicipalities.includes('0') ? 'all' : this.selectedMunicipalities.join(',')

        const startDate = this.selectedDates[0].split('/')
        const endDate = this.selectedDates[1].split('/')

        const units = this.selectedUnits.includes('0') === true ? 'all' : this.selectedUnits.map(unitName => window.btoa(unescape(encodeURIComponent(unitName)))).join(',')
        const generateUrl = `exportappointments/${this.$route.params.groupID}/${scaleId}/${municipalities}/${startDate[0]}-${startDate[1]}-${startDate[2]}/${endDate[0]}-${endDate[1]}-${endDate[2]}/${units}`

        //
        // TRY TO REQUEST THE REPORT
        //

        apiOpenReport(generateUrl)
      },
    },
  }

</script>

<style lang="sass">

  .appointmentsFieldPeriod

    width: 100%

    // .csFields--date input {
      // background-color: transparent !important

    .mx-input
      background-color: transparent !important

</style>

<style lang="sass" scoped>

  .sosField
    z-index: 2
    position: relative

    width: 100%

    // margin-top: 15px
    // margin-bottom: 15px
    // margin-top: 5px
    margin-bottom: 5px

    &.sosField--first
      margin-top: 0

    &.sosField--last
      margin-bottom: 0

  .sosFieldGroup
    z-index: 1
    position: relative

    // margin-top: 10px
    // margin-bottom: 10px
    margin-left: -5px
    margin-right: -5px

    .sosField
      display: inline-block
      vertical-align: middle
      padding: 0 5px
      // padding: 5px
      margin-top: 0
      margin-bottom: 0

      &.sosFieldColumn--1,
      &.sosFieldColumn--2
        width: 50%

  //

  .loaderGestor
    display: block
    height: 20px
    width: 20px
    -webkit-animation: loaderGestor 800ms linear infinite
    animation: loaderGestor 800ms linear infinite

  @-webkit-keyframes loaderGestor
    0%
      -webkit-transform: rotate(0deg)
    100%
      -webkit-transform: rotate(360deg)

  @keyframes loaderGestor
    0%
      transform: rotate(0deg)
    100%
      transform: rotate(360deg)

  .loaderGestor span
    display: block
    position: absolute
    top: 0
    left: 0
    bottom: 0
    right: 0
    margin: auto
    height: 20px
    width: 20px
    clip: rect(10px, 20px, 20px, 0)
    -webkit-animation: loaderGestor-2 400ms cubic-bezier(0.770, 0.000, 0.175, 1.000) infinite
    animation: loaderGestor-2 400ms cubic-bezier(0.770, 0.000, 0.175, 1.000) infinite

  @-webkit-keyframes loaderGestor-2
    0%
      -webkit-transform: rotate(0deg)
    100%
      -webkit-transform: rotate(360deg)

  @keyframes loaderGestor-2
    0%
      transform: rotate(0deg)
    100%
      transform: rotate(360deg)

  .loaderGestor span::before
    content: ""
    display: block
    position: absolute
    top: 0
    left: 0
    bottom: 0
    right: 0
    margin: auto
    height: 20px
    width: 20px
    border: 1px solid transparent
    border-top: 1px solid #000000
    border-radius: 50%
    -webkit-animation: loaderGestor-3 400ms cubic-bezier(0.770, 0.000, 0.175, 1.000) infinite
    animation: loaderGestor-3 400ms cubic-bezier(0.770, 0.000, 0.175, 1.000) infinite

  @-webkit-keyframes loaderGestor-3
    0%
      -webkit-transform: rotate(0deg)
    100%
      -webkit-transform: rotate(360deg)

  @keyframes loaderGestor-3
    0%
      transform: rotate(0deg)
    100%
      transform: rotate(360deg)

  .loaderGestor span::after
    content: ""
    display: block
    position: absolute
    top: 0
    left: 0
    bottom: 0
    right: 0
    margin: auto
    height: 20px
    width: 20px
    border: 1px solid rgba(0, 0, 0, 0.5)
    border-radius: 50%

  .btn
    position: relative

  @media (max-width: 1280px)
    .groupUserDuties
      overflow-x: auto

  @media (max-width: 768px)
    .groupUserDuties
      overflow-x: visible

</style>

<style scoped lang="scss">

  .pageBody {
    margin-top: 20px;
    // padding: 20px 30px;
    padding: 30px;
    border-radius: 5px;
    // border-top-left-radius: 5px;
    // border-top-right-radius: 5px;
    background-color: white;
    box-shadow: 0px 3px 7px -5px rgba(0, 0, 0, 0.5);
  }

  .pageGroupContainer {
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
  }

  .groupTitleArea {
    position: relative;

    // width: 100%;
    height: 80px;
    margin-bottom: 20px;
  }

  .groupTitleImage,
  .groupTitleText {
    display: inline-block;
    vertical-align: top;
  }

  .groupTitleImage {
    position: absolute;
    top: 0;
    left: 0;

    display: inline-block;
    vertical-align: middle;
    width: 80px;
    height: 80px;

    .groupImage {
      display: inline-block;
      width: 80px;
      height: 80px;
      overflow: hidden;
      border-radius: 7px;
      border: 1px solid rgba(0, 0, 0, 0.1);
      box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.1);

      .groupUserImage {
        display: inline-block;
        width: 100%;
        max-width: 80px;
        height: 80px;
        background-repeat: no-repeat;
        background-size: cover;
        background-color: rgba(0, 0, 0, 0.5);
      }
    }
  }

  .groupTitleText {
    position: absolute;
    top: 0;
    bottom: 0;

    display: inline-block;
    vertical-align: middle;
    width: 100%;
    height: 25px;
    margin: auto 0;
    padding-left: 100px;
  }

  .groupUserDutiesHeader {
    padding: 10px 30px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: steelblue;

    color: #FFFFFF;
    font-size: 18px;
    font-weight: 600;

    &--margin {
      margin-top: 30px;
    }
  }

  /* .groupUserDuties--loadingWrapper {
    transition-property: opacity, visibility;
    transition-duration: 200ms;

    opacity: 0;
    visibility: hidden;

    z-index: 1;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    background-color: rgba(0, 0, 0, 0.5);

    span {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;

      display: inline-block;
      height: 25px;
      margin: auto;

      color: #FFFFFF;
      font-weight: 500;
      text-align: center;
      line-height: 25px;
    }
  } */

  .groupUserDutiesMonthWrapper {
    transition-property: opacity;
    transition-duration: 200ms;
  }

  .appointmentDay {
    margin: 3px 0;
  }

  .appointmentDateTitle__icon,
  .appointmentDateTitle__amount {
    position: absolute;
    top: 0;
    bottom: 0;

    display: inline-block;
    vertical-align: middle;
    margin: auto 0;
  }

  .appointmentDateTitle__icon {
    left: 10px;

    width: 30px;
    height: 20px;
    // border-radius: 5px;
    /* box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.2); */
    /* background-color: darkslateblue; */

    color: #333333;
    // font-size: 25px;
    // font-weight: 300;
    // line-height: 25px;
    line-height: 0;
    text-align: center;

    & > i {
      display: inline-block;
      vertical-align: middle;
      height: 20px;
      font-size: 20px;
      line-height: 20px;
    }
  }

  .appointmentDateTitle__amount
  {
    right: 10px;

    height: 20px;
    padding: 0 5px;
    border-radius: 5px;
    box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.2);
    background-color: darkslateblue;

    color: #FFFFFF;
    font-size: 14px;
    line-height: 20px;
  }

  .appointmentDateTitle
  {
    transition-property: border-color, background-color;
    transition-duration: 200ms;

    // padding-top: 5px;
    // padding-bottom: 5px;
    // background-color: rgba(0, 0, 0, 0.1);

    cursor: pointer;

    position: relative;

    padding-left: 50px; // 10 + 40
    padding-top: 10px;
    padding-bottom: 10px;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0.1);
    box-shadow: 1px 1px 7px -5px inset rgba(0, 0, 0, 0.3);
    background-color: #f0f8ff;

    font-weight: 600;
    line-height: 1.5;

    &:hover {
      // color: #FFFFFF;
      border-color: rgba(0, 0, 0, 0.2);
      background-color: #e9f1f8;

      // .appointmentDateTitle__icon {
        // color: #FFFFFF;
      // }
    }
  }

  .appointmentDateBody
  {
    display: none;
    overflow: auto;

    border-left: 1px solid rgba(0, 0, 0, 0.1);
    // border-right: 1px solid rgba(0, 0, 0, 0.1);
    // border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  .tdPatientName {
    display: inline-block;
    vertical-align: middle;
    width: 100%;
    max-width: 150px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    // text-wrap: nowrap;
  }

  .tdSpecialtyName
  {
    display: inline-block;
    vertical-align: middle;
    // width: 100%;
    max-width: 150px;
    // padding: 3px 5px;
    // border-radius: 4px;
    // box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.7);
    // background-color: brown;

    overflow: hidden;

    text-overflow: ellipsis;
    white-space: nowrap;

    // color: #FFFFFF;
    color: brown;
    font-size: 13px; // 14px;
    font-weight: 500;
    line-height: 1;
  }

  .appointmentsTable
  {
    width: 100%;
    min-width: 1090px;

    td {
      padding-left: 10px;
      padding-right: 10px;
      padding-top: 5px;
      padding-bottom: 5px;

      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      border-right: 1px solid rgba(0, 0, 0, 0.1);
    }

    .managerUserItem {
      &--head {
        background-color: aliceblue;

        color: #483d8b;
        font-weight: 600;
      }
    }
  }

  .appointmentDay--expanded {
    .appointmentDateBody {
      // max-height: none
      display: block;
    }
  }

  .groupUserDuties {
    position: relative;
    padding: 7px 10px;
    // padding: 27px;
    border-left: 1px solid rgba(70, 130, 180);
    border-right: 1px solid rgba(70, 130, 180);
    border-bottom: 1px solid rgba(70, 130, 180);
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;

    &.groupUserDuties--loading {
      /* .groupUserDuties--loadingWrapper {
        opacity: 1;
        visibility: visible;
      } */

      .groupUserDutiesMonthWrapper {
        opacity: 0.2;
      }
    }
  }

  //
  //
  //

  p {
    margin: 0;
  }

  /* ul {
    list-style: none;
  } */

  /*  */

  .column {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    @media (min-width: 767px) {
      justify-content: center;
    }
    &[start] {
      justify-content: flex-start;
    }
    &[end] {
      justify-content: flex-end;
    }
    &[space-between] {
      justify-content: space-between;
    }
  }

  .blockTitle {
    overflow: hidden;

    color: #305050;
    font-size: 25px;
    line-height: 1;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .csCol {
    display: inline-block;
    vertical-align: top;

    &.csCol--1 {
      width: 50%;
      // width: 40%;
    }

    &.csCol--2 {
      width: 50%;
      // width: 40%;
    }

    // &.csCol--3 {
      // width: 20%;
    // }
  }

  // .csCol--3 {
    // text-align: right;
  // }

  //
  //
  //

  @media (max-width: 1280px)
  {
    .csCol {
      &.csCol--1 {
        width: 50%;
      }

      &.csCol--2 {
        width: 50%;
      }

      // &.csCol--3 {
        // width: 100%;
        // margin-top: 25px;

        // text-align: center;
      // }
    }
  }

  /* @media (max-width: 1164px)
  {
    .groupTitleImage {
      width: 30%;
    }

    .groupTitleText {
      width: 70%;
    }
  } */

  @media (max-width: 960px)
  {
    .groupTitleArea {
      position: relative;
    }

    /* .groupTitleImage {
      position: absolute;
      left: 0;
      top: 0;

      width: 100%;
    }

    .groupTitleText {
      width: 100%;
      padding-left: 100px;
    } */

    .csCol {
      &.csCol--1 {
        width: 100%;
      }

      &.csCol--2 {
        width: 100%;
        margin-top: 35px;
      }

      // &.csCol--3 {
        // width: 100%;
      // }
    }
  }

  // @media (max-width: 1280px)
    // .groupTabBody
      // overflow-x: auto
    // .appointmentsTable
      // min-width: 1164px

  @media (max-width: 768px)
  {
    .tdPatientName
    {
      /* width: auto; */
      max-width: none;

      white-space: normal;
    }

    .appointmentDateBody
    {
      border-left: 0;
    }

    .appointmentsTable
    {
      min-width: 0;

      // span {
        // &.scaleItemName {
          // padding-right: 0;
        // }
      // }

      thead {
        border: none;
        clip: rect(0 0 0 0);
        height: 1px;
        margin: -1px;
        overflow: hidden;
        padding: 0;
        position: absolute;
        width: 1px;
      }

      .managerUserItem {
        display: block;
        margin: 10px 0;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
        border-left: 1px solid rgba(0, 0, 0, 0.1);
        border-right: 1px solid rgba(0, 0, 0, 0.1);
        border-bottom: 3px solid #ddd;
        border-radius: 10px;
        background-color: aliceblue;

        color: #483d8b;
        // font-weight: 600;

        td {
          display: block;
          // text-align: right !important;
          text-align: left !important;
          padding: 3px 15px !important;
          // // padding: 10px 20px !important;

          // 600px
          line-height: 18px;
          // 600px

          &::before {
            content: attr(data-label);
            // float: left;
            font-weight: bold;
            // text-transform: uppercase;

            // 600px
            float: none;
            display: block;
            width: 100%;
          }

          &:last-child {
            border-bottom: 0;
          }
        }

        &.last {
          th,
          td {
            border-bottom: 1px solid rgba(0, 0, 0, 0.05);
          }
        }
      }
    }
  }

  @media (max-width: 600px)
  {
    .btnVoltar {
      width: 100%;
    }

    /* .appointmentsTable
    {
      .managerUserItem {
        td {
          text-align: left !important;

          &::before {
            float: none;
            display: block;
            width: 100%;
          }
        }
      }
    } */
  }

</style>
